import { Tag as AntdTag } from 'antd'

export const Tag = AntdTag
